document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.getElementById('MenuToggle');
  var nav = document.getElementById('SiteNav');
  if (toggle && nav) {
    toggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }

  var thumbs = document.querySelectorAll('.main-product__thumb');
  var mainImage = document.getElementById('ProductMainImage');
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      if (mainImage) mainImage.src = thumb.dataset.full;
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
    });
  });

  var variantsJsonEl = document.getElementById('ProductVariantsJson');
  if (variantsJsonEl) {
    var variants = JSON.parse(variantsJsonEl.textContent);
    var optionGroups = document.querySelectorAll('.option-group');
    var variantIdInput = document.getElementById('ProductVariantId');
    var priceEl = document.getElementById('ProductPrice');
    var addToCartBtn = document.getElementById('AddToCartBtn');

    function moneyFormat(cents) {
      return '$' + (cents / 100).toFixed(2);
    }

    function getSelectedOptions() {
      var selected = [];
      optionGroups.forEach(function (group) {
        var active = group.querySelector('.option-pill.is-active');
        selected.push(active ? active.dataset.value : null);
      });
      return selected;
    }

    function findMatchingVariant() {
      var selected = getSelectedOptions();
      return variants.find(function (v) {
        var opts = [v.option1, v.option2, v.option3].slice(0, selected.length);
        return opts.every(function (val, i) { return val === selected[i]; });
      });
    }

    function updateForVariant(variant) {
      if (!variant) return;
      if (variantIdInput) variantIdInput.value = variant.id;
      if (priceEl) priceEl.childNodes[0].textContent = moneyFormat(variant.price) + ' ';
      if (addToCartBtn) {
        if (variant.available) {
          addToCartBtn.disabled = false;
          addToCartBtn.textContent = 'Add to cart';
        } else {
          addToCartBtn.disabled = true;
          addToCartBtn.textContent = 'Sold out';
        }
      }
    }

    optionGroups.forEach(function (group) {
      var pills = group.querySelectorAll('.option-pill');
      pills.forEach(function (pill) {
        pill.addEventListener('click', function () {
          pills.forEach(function (p) { p.classList.remove('is-active'); });
          pill.classList.add('is-active');
          updateForVariant(findMatchingVariant());
        });
      });
    });
  }

  var carousel = document.getElementById('HeroCarousel');
  if (carousel) {
    var slides = carousel.querySelectorAll('.hero-carousel__slide');
    var dots = carousel.querySelectorAll('.hero-carousel__dot');
    var current = 0;
    var intervalId;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      dots[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
      dots[current].classList.add('is-active');
    }

    function startAutoplay() {
      intervalId = setInterval(function () { goTo(current + 1); }, 5000);
    }

    function resetAutoplay() {
      clearInterval(intervalId);
      startAutoplay();
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
        resetAutoplay();
      });
    });

    var prevBtn = document.getElementById('HeroPrev');
    var nextBtn = document.getElementById('HeroNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current - 1); resetAutoplay(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current + 1); resetAutoplay(); });

    if (slides.length > 1) startAutoplay();
  }

  var revealTargets = document.querySelectorAll('.value-props, .process-steps, .category-tiles, .trust-badges, .about-page__values, .about-page__purpose, .about-page__team, .contact-page__info, .contact-page__form, .main-collection__description, .main-product__info, .main-product__gallery');
  revealTargets.forEach(function (el) { el.classList.add('reveal'); });
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 });
    revealTargets.forEach(function (el) { observer.observe(el); });
  } else {
    revealTargets.forEach(function (el) { el.classList.add('is-visible'); });
  }
});
